import { collection, getDocs } from "firebase/firestore";
import React, { CSSProperties, useEffect, useState } from "react";
import { db } from "../../firebase";
import BookUpload from "./bookadmin";
import { bookData as staticBooks } from "./staticbook"; // ⬅️ Move your hardcoded list into a separate file

const styles: { [key: string]: CSSProperties } = {
  container: { padding: "20px", maxWidth: "1200px", margin: "0 auto" },
  title: { fontSize: "24px", fontWeight: "bold", marginBottom: "10px" },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "30px",
    marginBottom: "10px",
    color: "#333",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "20px",
    width: "100%",
    margin: "0 auto",
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "15px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    maxWidth: "100%",
    margin: "0 auto",
    textAlign: "left",
  },
  cardHeader: {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "10px",
  },
  cardItem: { marginBottom: "5px", textAlign: "left" },
  bookCover: {
    width: "80px",
    height: "120px",
    objectFit: "cover",
    marginBottom: "10px",
  },
  date: { fontSize: "12px", fontStyle: "italic" },
  icon: { fontSize: "16px", marginRight: "5px" },
};

interface BookData {
  title: string;
  author: string;
  rating: string;
  comments: string;
  date: string;
  status: string;
  type: string;
  cover: string;
}

const sortByRating = (a: BookData, b: BookData) => {
  const ratingA = parseFloat(a.rating.split("/")[0]);
  const ratingB = parseFloat(b.rating.split("/")[0]);
  return ratingB - ratingA;
};

const BookClub: React.FC = () => {
  const [dynamicBooks, setDynamicBooks] = useState<BookData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const snapshot = await getDocs(collection(db, "books"));
        const data = snapshot.docs.map((doc) => doc.data() as BookData);
        setDynamicBooks(data);
      } catch (error) {
        console.error("Failed to fetch books from Firebase:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  const allBooks = [...staticBooks, ...dynamicBooks];

  const currentlyReading = allBooks
    .filter(
      (book) =>
        book.status === "Still reading book" ||
        book.status === "Still listening audiobook"
    )
    .sort(sortByRating);

  const finishedBooks = allBooks
    .filter((book) => book.status === "Finished book")
    .sort(sortByRating);

  const finishedAudiobooks = allBooks
    .filter((book) => book.status === "Finished audiobook")
    .sort(sortByRating);

  const renderSection = (title: string, books: BookData[]) => (
    <>
      <h3 style={styles.sectionTitle}>{title}</h3>
      <div style={styles.gridContainer}>
        {books.map((book, index) => (
          <div key={`${book.title}-${index}`} style={styles.card}>
            <img src={book.cover} alt={book.title} style={styles.bookCover} />
            <div style={styles.cardHeader}>
              {book.title}{" "}
              <span style={styles.icon}>
                {book.type === "audiobook" ? "🎧" : "📕"}
              </span>
            </div>
            <p style={styles.cardItem}>
              <strong>Author:</strong> {book.author}
            </p>
            <p style={styles.cardItem}>
              <strong>Rating:</strong> {book.rating}
            </p>
            <p style={styles.cardItem}>
              <strong>Comments:</strong> {book.comments}
            </p>
            <p style={styles.cardItem}>
              <strong>Date:</strong>{" "}
              <span style={styles.date}>{book.date}</span>
            </p>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Book Club</h2>
      <p>Welcome to the book club! Here are the books we are reading.</p>

      {loading ? (
        <p>Loading books...</p>
      ) : (
        <>
          {renderSection("Currently Reading", currentlyReading)}
          {renderSection("Books I Like", finishedBooks)}
          {renderSection("Finished Audiobooks", finishedAudiobooks)}
        </>
      )}

      <BookUpload onUpload={() => window.location.reload()} />
    </div>
  );
};

export default BookClub;
